import React, { useState, useEffect } from 'react';
import './App.css';

function App() {
  const [isLoaded, setIsLoaded] = useState(false);

  useEffect(() => {
    setIsLoaded(true);
  }, []);

  const experiences = [
    {
      period: "Mar 2025 - Present",
      title: "AI Engineer",
      company: "AppliedAI",
      location: "Abu Dhabi, United Arab Emirates",
      logo: "/applied-ai-logo.png",
      link: "https://appliedai.opus.com/"
    },
    {
      period: "Sep 2024 - Feb 2025",
      title: "Software Engineer",
      company: "Paris Digital Lab",
      location: "Paris, France",
      logo: "/pdl-logo.png",
      link: "https://paris-digital-lab.com/"
    },
    {
      period: "Sep 2023 - Jun 2024",
      title: "Project Manager",
      company: "Festival de Cannes",
      location: "Paris and Cannes, France",
      logo: "/festival-logo.png",
      link: "https://www.festival-cannes.com/en/"
    },
    {
      period: "2022 - 2023",
      title: "CSM Data Quality",
      company: "Deepki",
      location: "Paris, France",
      logo: "/deepki-logo.png",
      link : "https://deepki.com/"
    },
    {
      period: "2022 (6 months)",
      title: "Strategic Analyst",
      company: "Edenred",
      location: "Paris, France",
      logo: "/edenred-logo.png",
      link: "https://www.edenred.fr/"
    }
  ];

  const education = [
    {
      period: "2019 - 2023",
      degree: "Master in Engineering",
      school: "CentraleSupélec - Université Paris-Saclay",
      logo: "/centrale-logo.png",
      link: "https://www.centralesupelec.fr/en/"
    },
    {
      period: "2018 - 2021",
      degree: "Master in Management",
      school: "ESCP Business School",
      logo: "/escp-logo.png",
      link: "https://escp.eu/"
    },
    {
      period: "2016 - 2019",
      degree: "Bachelor in Mathematics & Computer Science",
      school: "Université Paris I Panthéon-Sorbonne",
      logo: "/sorbonne-logo.png",
      link: "https://www.pantheonsorbonne.fr/"
    },
    {
      period: "2016 - 2018",
      degree: "Preparation Class - ECS",
      school: "Janson-de-Sailly",
      logo: "/js-logo.png",
      link: "https://www.lycee-janson-de-sailly.fr/"
    },
  ];

  const projects = [
    {
      name: "bioQuery",
      description: "AI-powered app that delivers reliable, up-to-date summaries of cosmetic and food ingredients. Leverages Retrieval-Augmented Generation (RAG) and Python to synthesize information from scientific literature.",
      tech: "RAG, Python, FastAPI, LangChain, Llama, OpenAI, PostgreSQL, TypeScript, React",
      logo: "/bioquery-logo.svg",
      link: "https://github.com/ines-adn/bioQuery"
    }
  ];

  const papers = [
    {
      name: "Opus: A Prompt Intention Framework For Complex Workflow Generation",
      description: "In this paper, we introduce the Opus Prompt Intention Framework, which adds an intermediate Intention Capture layer between user queries and workflow generation using instruction-tuned LLMs.",
      logo: "/applied-ai-logo.png",
      link: "https://arxiv.org/abs/2507.11288",
      authors: "Théo Fagnoni, Mahsun Altin, Chia En Chung, Phillip Kingston, Alan Tuning, Dana O. Mohamed, Inès Adnani"
    }
  ]

  const certifications = [
    {
      title: "Structuring ML Projects",
      issuer: "DeepLearning.AI",
      date: "Jun 2025",
      link: "https://coursera.org/share/38a44ff7321186cdda0e61c340fceadf"
    },
    {
      title: "Deep Neural Networks",
      issuer: "DeepLearning.AI", 
      date: "May 2025",
      link: "https://coursera.org/share/ae9d0e6ac8a5805d294e6197d88c623f"
    },
    {
      title: "Neural Networks & Deep Learning",
      issuer: "DeepLearning.AI",
      date: "May 2025",
      link: "https://coursera.org/share/729b9f95eab2a752276f28abad9c44f1"
    }
  ];

  const skills = {
    technical: ["Python", "AWS/Bedrock", "JavaScript/TypeScript", "GitHub/GitLab", "PostegreSQL", "FastAPI", "React", "Node.js", "Machine Learning", "Data Analysis", "RAG (Retrieval-Augmented Generation)", "LangChain", "OpenAI API"],
    languages: ["French (Native)", "English (C2)", "Spanish (C2)", "Italian (A1)"]
  };

  return (
    <div className={`App ${isLoaded ? 'loaded' : ''}`}>
      {/* Top Bar */}
      <div className="top-bar">
        <div className="container">
          <div className="top-bar-content">
            <div className="logo">Portfolio | ines-adn </div>
            <div className="top-bar-icons">
              <a href="https://github.com/ines-adn" target="_blank" rel="noopener noreferrer" className="icon-link">
                <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
                  <path d="M12 0C5.37 0 0 5.37 0 12c0 5.31 3.435 9.795 8.205 11.385.6.105.825-.255.825-.57 0-.285-.015-1.23-.015-2.235-3.015.555-3.795-.735-4.035-1.41-.135-.345-.72-1.41-1.23-1.695-.42-.225-1.02-.78-.015-.795.945-.015 1.62.87 1.845 1.23 1.08 1.815 2.805 1.305 3.495.99.105-.78.42-1.305.765-1.605-2.67-.3-5.46-1.335-5.46-5.925 0-1.305.465-2.385 1.23-3.225-.12-.3-.54-1.53.12-3.18 0 0 1.005-.315 3.3 1.23.96-.27 1.98-.405 3-.405s2.04.135 3 .405c2.295-1.56 3.3-1.23 3.3-1.23.66 1.65.24 2.88.12 3.18.765.84 1.23 1.905 1.23 3.225 0 4.605-2.805 5.625-5.475 5.925.435.375.81 1.095.81 2.22 0 1.605-.015 2.895-.015 3.3 0 .315.225.69.825.57A12.02 12.02 0 0024 12c0-6.63-5.37-12-12-12z"/>
                </svg>
              </a>
              <a href="https://www.linkedin.com/in/ines-adnani/" target="_blank" rel="noopener noreferrer" className="icon-link">
                <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
                  <path d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433a2.062 2.062 0 01-2.063-2.065 2.064 2.064 0 112.063 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z"/>
                </svg>
              </a>
              <a href="mailto:ines.adnani@aaico.com" className="icon-link">
                <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
                  <path d="M24 5.457v13.909c0 .904-.732 1.636-1.636 1.636h-3.819V11.73L12 16.64l-6.545-4.91v9.273H1.636A1.636 1.636 0 010 19.366V5.457c0-.904.732-1.636 1.636-1.636h.727L12 10.33l9.637-6.51h.727c.904 0 1.636.732 1.636 1.636z"/>
                </svg>
              </a>
              <button className="theme-toggle">
                <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
                  <path d="M12 3a6 6 0 006 6 6 6 0 006-6 6 6 0 00-6-6 6 6 0 00-6 6z"/>
                  <path d="M19.14 12.94c.04-.3.06-.61.06-.94a7.014 7.014 0 00-7-7c-.33 0-.64.02-.94.06a5.014 5.014 0 000 9.88c.3.04.61.06.94.06a7.014 7.014 0 007-7c0-.33-.02-.64-.06-.94z"/>
                </svg>
              </button>
            </div>
          </div>
        </div>
      </div>

      {/* Header */}
      <header className="header">
        <div className="container">
          <div className="header-content">
            <div className="header-left">
              <div className="profile-image">
                <div className="image-placeholder">
                    <img src="/ines-photo.png" alt="Ines Adnani" />
                </div>
              </div>
              <div className="header-text">
                <h1 className="name">Ines Adnani</h1>
                <h2 className="title">Machine Learning & Software Engineer</h2>
                <p className="subtitle">MEng (CentraleSupélec) & MiM (ESCP Business School) Graduate</p>
                <p className="bio">I’m an engineer and business graduate with a background in mathematics, software engineering, and AI. I hold degrees from Sorbonne University, CentraleSupélec, and ESCP, and have worked across industries ranging from cinema to data quality and machine learning. I’m passionate about building products that combine technology, creativity, and real-world impact.</p>
              </div>
            </div>
            <div className="contact-info">
              <p>📧 <a href="mailto:ines.adnani@aaico.com.fr">ines.adnani@aaico.com</a></p>
              <p>📱 +60 11 37 84 98 84</p>
              <p>🔗 <a href="https://www.linkedin.com/in/ines-adnani/" target="_blank" rel="noopener noreferrer">LinkedIn</a></p>
              <p>🔗 <a href="https://github.com/ines-adn" target="_blank" rel="noopener noreferrer">GitHub</a></p>
            </div>
          </div>
        </div>
      </header>

      {/* Main Content */}
      <main className="main-content">
        <div className="container">
          {/* Experience and Education Row */}
          <div className="two-column-layout">
            <div className="experience-box">
              <h3 className="box-title">EXPERIENCES</h3>
              <div className="experience-list">
                {experiences.map((exp, index) => (
  <div 
    key={index} 
    className="experience-item"
    onClick={() => window.open(exp.link, '_blank')}
  >
    <div className="experience-content">
      <div className="company-logo">
        <img src={exp.logo} alt={`${exp.company} logo`} />
      </div>
      <div className="experience-details">
        <div className="experience-header">
          <h4 className="job-title">{exp.title}</h4>
          <span className="period">{exp.period}</span>
        </div>
        <div className="company-location">
          <span className="company">{exp.company}</span>
          <span className="location">{exp.location}</span>
        </div>
      </div>
    </div>
  </div>
))}
              </div>
            </div>

            <div className="education-box">
              <h3 className="box-title">EDUCATION</h3>
              <div className="education-list">
                {education.map((edu, index) => (
  <div 
    key={index} 
    className="education-item"
    onClick={() => window.open(edu.link, '_blank')}
  >
    <div className="education-content">
      <div className="school-logo">
        <img src={edu.logo} alt={`${edu.school} logo`} />
      </div>
      <div className="education-details">
        <div className="education-header">
          <h4 className="degree">{edu.degree}</h4>
          <span className="period">{edu.period}</span>
        </div>
        <div className="school">{edu.school}</div>
      </div>
    </div>
    {/* Add tooltip */}
    {edu.school.includes('CentraleSupélec') && (
      <div className="tooltip">
        France's top engineering school, part of Paris-Saclay University, ranked #12 globally for overall academics (Shanghai ranking), #2 for Mathematics. Prestigious institution known for producing world-class engineers and researchers in technology and science.
      </div>
    )}
    {edu.school.includes('ESCP') && (
      <div className="tooltip">
        Europe's first business school (1819) with campuses in 6 cities across Europe. The Master in Management program ranks #6 worldwide (Financial Times), offering students the opportunity to study in multiple countries.
      </div>
    )}
  </div>
))}

              </div>
            </div>
          </div>

          {/* Projects and Skills Row */}
          <div className="projects-skills-layout"> 
            <div className="projects-box">
              <h3 className="box-title">PROJECTS</h3>
              <div className="projects-list">
                {projects.map((project, index) => (
  <div 
    key={index} 
    className="project-item"
    onClick={() => window.open(project.link, '_blank')}
  >
    <div className="project-content">
      <div className="project-text">
        <h4 className="project-name">{project.name}</h4>
        <p className="project-description">{project.description}</p>
        <div className="project-tech">{project.tech}</div>
      </div>
      <div className="project-logo">
        <img src={project.logo} alt={`${project.name} logo`} />
      </div>
    </div>
  </div>
))}
                </div>
              </div>
            <div className="skills-box">
              <h3 className="box-title">SKILLS</h3>
              <div className="skills-content">
                <div className="skill-group">
                  <h4>Technical</h4>
                  <div className="skill-tags">
                    {skills.technical.map((skill, index) => (
                      <span key={index} className="skill-tag">{skill}</span>
                    ))}
                  </div>
                </div>
                <div className="skill-group">
                  <h4>Languages</h4>
                  <div className="skill-tags">
                    {skills.languages.map((lang, index) => (
                      <span key={index} className="skill-tag">{lang}</span>
                    ))}
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Certifications and Papers Layout */}
        <div className="certifications-papers-layout">
          {/* Certifications */}
          <div className="certifications-box">
            <h3 className="box-title">CERTIFICATIONS</h3>
            <div className="certifications-list">
              {certifications.map((cert, index) => (
                <div 
                  key={index} 
                  className="certification-item"
                  onClick={() => window.open(cert.link, '_blank')}
                >
                  <h4 className="cert-title">{cert.title}</h4>
                  <div className="cert-details">
                    <span className="cert-issuer">{cert.issuer}</span>
                    <span className="cert-date">{cert.date}</span>
                  </div>
                </div>
              ))}
            </div>
          </div>

          {/* Papers */}
          <div className="papers-box">
            <h3 className="box-title">PAPERS</h3>
            <div className="papers-list">
              {papers.map((paper, index) => (
                <div
                  key={index}
                  className="paper-item"
                  onClick={() => window.open(paper.link, '_blank')}
                >
                    <h4 className="paper-title">{paper.name}</h4>
                    <p className="paper-description">{paper.description}</p>
                    <p className="paper-authors">{paper.authors}</p>
                    <div className="paper-logo">
                    <img src={paper.logo} alt={`${paper.name} logo`} />
                    </div>
                </div>
              ))}
            </div>
          </div>
        </div>
        </div>
              </main>

      {/* Footer */}
      <footer className="footer">
        <div className="container">
          <div className="footer-content">
            <div className="contact-section">
              <h3>Contact me</h3>
              <p>Do not hesitate to contact me for any project!</p>
              <div className="contact-boxes">
                <a href="mailto:ines.adnani@aaico.com" className="contact-box">
                  <div className="contact-icon">
                    <svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor">
                      <path d="M24 5.457v13.909c0 .904-.732 1.636-1.636 1.636h-3.819V11.73L12 16.64l-6.545-4.91v9.273H1.636A1.636 1.636 0 010 19.366V5.457c0-.904.732-1.636 1.636-1.636h.727L12 10.33l9.637-6.51h.727c.904 0 1.636.732 1.636 1.636z"/>
                    </svg>
                  </div>
                  <span>Email</span>
                </a>
                <a href="https://github.com/ines-adn" target="_blank" rel="noopener noreferrer" className="contact-box">
                  <div className="contact-icon">
                    <svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor">
                      <path d="M12 0C5.37 0 0 5.37 0 12c0 5.31 3.435 9.795 8.205 11.385.6.105.825-.255.825-.57 0-.285-.015-1.23-.015-2.235-3.015.555-3.795-.735-4.035-1.41-.135-.345-.72-1.41-1.23-1.695-.42-.225-1.02-.78-.015-.795.945-.015 1.62.87 1.845 1.23 1.08 1.815 2.805 1.305 3.495.99.105-.78.42-1.305.765-1.605-2.67-.3-5.46-1.335-5.46-5.925 0-1.305.465-2.385 1.23-3.225-.12-.3-.54-1.53.12-3.18 0 0 1.005-.315 3.3 1.23.96-.27 1.98-.405 3-.405s2.04.135 3 .405c2.295-1.56 3.3-1.23 3.3-1.23.66 1.65.24 2.88.12 3.18.765.84 1.23 1.905 1.23 3.225 0 4.605-2.805 5.625-5.475 5.925.435.375.81 1.095.81 2.22 0 1.605-.015 2.895-.015 3.3 0 .315.225.69.825.57A12.02 12.02 0 0024 12c0-6.63-5.37-12-12-12z"/>
                    </svg>
                  </div>
                  <span>GitHub</span>
                </a>
                <a href="https://www.linkedin.com/in/ines-adnani/" target="_blank" rel="noopener noreferrer" className="contact-box">
                  <div className="contact-icon">
                    <svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor">
                      <path d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433a2.062 2.062 0 01-2.063-2.065 2.064 2.064 0 112.063 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z"/>
                    </svg>
                  </div>
                  <span>LinkedIn</span>
                </a>
              </div>
            </div>
            <div className="footer-bottom">
              <p>© 2025 Ines Adnani | Made with ❤️ by Ines</p>
            </div>
          </div>
        </div>
      </footer>

      {/* Background Animation */}
      <div className="background-animation">
        <div className="floating-shape shape-1"></div>
        <div className="floating-shape shape-2"></div>
        <div className="floating-shape shape-3"></div>
      </div>
    </div>
  );
}

export default App;
